import NGODashboardLayout from "layout/dashboardlayout/ngodashboardlayout.js";
import React, { useState } from "react";
import ProgressBar from "../components/ProgressBar";
import { TKIconSpinner, TKIconUpload } from "assets/images/svgs";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { singleUpload } from "appState/upload/uploadSlice";

const CreateProjectTwo = ({ next, body, setBody }) => {
  const [selectedVideo, setSelectedVideo] = useState("");
  const [selectedVideoFile, setSelectedVideoFile] = useState(null);
  const [uploadedImage, setUploadedImage] = useState("");
  // const [uploadedVideo, setUploadedVideo] = useState(null);

  const { isLoading } = useSelector((state) => state.upload);

  const dispatch = useDispatch();

  const uploadImage = (e) => {
    e.preventDefault();
    const fileTypes = ["image/png", "image/jpeg", "image/jpg"];

    if (e.target.files[0] && fileTypes.includes(e.target.files[0].type)) {
      if (e.target.files[0].size <= 3000000) {
        const formData = new FormData();
        formData.append("image", e.target.files[0], e.target.files[0].name);

        dispatch(singleUpload(formData)).then((data) => {
          if (data?.payload?.status === 200) {
            setUploadedImage(data?.payload?.data?.imageUrl);
          }
        });
      } else {
        toast.error("Please select a image file less than 3mb");
        return;
      }
    } else {
      toast.error("Please select a image file (PNG or JPEG or JPG)");
      return;
    }
  };

  const handleVideoChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    setSelectedVideoFile(file);

    if (file) {
      if (file.size <= 10000000) {
        const reader = new FileReader();
        reader.onload = () => {
          setSelectedVideo(reader.result);
        };
        const formData = new FormData();
        formData.append("image", file, file.name);

        dispatch(singleUpload(formData)).then((data) => {
          if (data?.payload?.status === 200) {
            // setUploadedImage(data?.payload?.data?.imageUrl);
          }
        });
        reader.readAsDataURL(file);
      } else {
        toast.error("Please select a video less than 10mb");
        return;
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setBody({
      ...body,
      project_picture: uploadedImage,
      impact_video: selectedVideo,
    });
    next();
  };

  return (
    <NGODashboardLayout section="Create New Project">
      <div className="flex flex-col px-6 max-[450px]:px-0 gap-4">
        <ProgressBar progress="w-[67%]" />
        <div>
          <div className="flex flex-col">
            <div className="flex justify-between items-center">
              <p className="text-[#222] font-semibold text-[28px]">
                Create Project
              </p>
              {
                // <TKIconClose />
              }
            </div>
            <p className="text-[#7A7A7A] text-[18px] font-light">
              Please provide information about the projects you will like
              fundraise for on the Truekeepers website.
            </p>
            <p className="text-[#7A7A7A] text-[18px] font-light">
              <span className="font-bold">Note:</span> You can list information
              for a maximum of 3 projects
            </p>
          </div>
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-3">
                <p className="text-[#213874] text-[14px] whitespace-nowrap">
                  Project Media
                </p>
                <div className="h-[1px] w-full bg-[#CCC]"></div>
              </div>
              <p className="text-[#7A7A7A] font-light">
                In this section please provide high definition images and videos
                for projects listed above
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="rounded-full text-white w-[35px] h-[35px] bg-[#DFDFDF] px-3 py-2 flex justify-center items-center">
                1
              </div>
              {isLoading ? (
                <div className="w-full flex justify-center">
                  <TKIconSpinner />
                </div>
              ) : (
                <div className="w-full flex flex-col gap-2">
                  <label className="text-[18px]">Project Picture</label>
                  <label className="flex justify-center items-center w-full h-[200px] rounded-lg border border-[#DFDFDF]">
                    {uploadedImage ? (
                      <div className="w-full h-full">
                        <img
                          src={uploadedImage}
                          className="w-full h-full object-contain"
                          alt="Project"
                        />
                      </div>
                    ) : (
                      <div className="flex flex-col items-center w-[150px]">
                        <TKIconUpload />
                        <p>
                          Drag file here to upload or{" "}
                          <span className="underline text-[#213874]">
                            choose file
                          </span>
                        </p>
                      </div>
                    )}
                    <input
                      type="file"
                      name="project_picture"
                      onChange={(e) => {
                        uploadImage(e);
                      }}
                      className="hidden"
                    />
                  </label>
                </div>
              )}
            </div>
            <div className="flex items-start gap-3">
              <div className="rounded-full text-white w-[35px] h-[35px] bg-[#DFDFDF] px-3 py-2 flex justify-center items-center">
                2
              </div>
              <div className="w-full flex flex-col gap-2">
                <label className="text-[18px]">Impact Video (optional)</label>
                <label className="text-[14px] text-[#7A7A7A]">
                  *Please upload a video that tells a compelling story of your
                  organization's impact over the years. <br />
                  *If you don't have an impact video, you may upload a video of
                  the founder or anyone in leadership speaking about why you
                  founded your organization and how you hope to make an impact
                  with your projects <br />
                  *Uploaded video must not be longer than 1minute and must have
                  a maximum file size of 5mb
                </label>

                <label className="flex justify-center items-center w-full h-[200px] rounded-lg border border-[#DFDFDF]">
                  {selectedVideoFile ? (
                    <video controls className="w-full h-full">
                      <source
                        src={URL.createObjectURL(selectedVideoFile)}
                        type={selectedVideoFile.type}
                      />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <div className="flex flex-col items-center w-[150px]">
                      <TKIconUpload />
                      <p>
                        Drag file here to upload or{" "}
                        <span className="underline text-[#213874]">
                          choose file
                        </span>
                      </p>
                    </div>
                  )}
                  <input
                    type="file"
                    name="impact_video"
                    className="w-0"
                    accept="video/*"
                    onChange={(e) => handleVideoChange(e)}
                    // value={selectedVideo}
                  />
                </label>
              </div>
            </div>
          </div>
          <div className="flex justify-end gap-3">
            <button type="button">
              <p className="p-3 bg-[#CCC] rounded-md">Back</p>
            </button>
            <button type="submit">
              <p className="p-3 bg-[#213874] text-white rounded-md">Next</p>
            </button>
          </div>
        </form>
      </div>
    </NGODashboardLayout>
  );
};

export default CreateProjectTwo;
